import React from "react";
import { withRouter } from "react-router-dom";
import AddPet from "~/components/addPet";

const AddPetPage = () => {
	return <AddPet />;
};

export default withRouter(AddPetPage);
